'use strict';

const ajax = require('./modules/ajax'),
    ritualsStyles = require('./rituals-styles'),
    responsiveBg = require('./responsive-background'),
    grid = require('./grid'),
    video = require('./video'),
    gtm = require('./modules/google'),
    slickSlider = require('./slick-slider'),
    productSlider = require('./product-slider'),
    isSmallView = require('./modules/helpers/isSmallView'),
    productFilter = require('./product-filter'),
    collectionIngredients = require('./pages/collection/collection-ingredients'),
    productDescription = require('./product-description'),
    dragList = require('./dragList');

let numberOfAcceptedAnswers,
    minAcceptedAnswers,
    maxAcceptedAnswers,
    currentQuestionNo,
    quizNamePrefix,
    hairTempleLoadingPage,
    startPage,
    totalQuestionsNumber,
    loadPrevAnswers = false,
    totalSelectedOptions = [],
    outcome;

/**
* @private
* @enum
* @description
*/
const QuizOptionTypes = {
    Regular: 0,
    HairTemple: 1
};

/**
* @private
* @function
* @description Initializes events for the quiz block
*/
function initEvents() {
    initStartAnimation();

    $(document).on('click', '.js-option-block', function(){
        toggleAnswer($(this));
    });

    $(document).on('click', '.js-retake-quiz', function(){
        clearData();
    });

    $(document).on('click', '.js-start-quiz, .js-next-question', function(e){
        e.preventDefault();

        if (!$(e.target).attr('disabled')) {
            if ($(e.target).hasClass('js-next-question')){
                // do next question logic (update answer values, calculations, etc.)
                saveSelectedOptions();
            }

            const selectedOptions = getSelectedOptions();
            let href;

            // If 1 option is selected
            if (selectedOptions.length === 1) {
                href = getLinkToFromSelectedOption() || $(e.target).attr('href');
            } else {
                // Default behaviour when multiple options are selected
                href = $(e.target).attr('href');
            }

            getQuestion(href);
        }
    });

    $(document).on('click', '.js-prev-question', function(e){
        e.preventDefault();

        if (!$(e.target).attr('disabled')) {
            loadPrevAnswers = true;

            const href = $(e.target).attr('href');

            getQuestion(href);
        }
        initStartAnimation();
    });


    $(document).on('click', '.js-quiz-last-question', function(e){
        e.preventDefault();

        saveSelectedOptions();
        calculateAndShowResult();
    });

    $(document).on('click', '.js-more-info-toggle', function(){
        $('.js-content-banner').toggleClass('showing-more-info');
    });

    $(document).on('keydown', '.js-more-info-toggle', function (event) {
        if (event.which == 13 || event.which == 32) {
            event.preventDefault();
            $(this).trigger('click');
        }
    });

    $(document).on('keydown', '.js-option-block', function (event) {
        if (event.which == 13 || event.which == 32) {
            event.preventDefault();
            $(this).trigger('click');
        }
    });

    $(document).on('keydown', '.js-question input[type=text]', function (event) {
        if (event.which == 13) {
            event.preventDefault();
            $('.js-question .js-next-question,.js-quiz-last-question').trigger('click');
        }
    });

    accessibilityCheckboxAdjustment();

    $(window).on('load scroll', function () {
        stickyNavButtons();
    });

    $(window).on('load', function () {
        if ($('.js-collection-ingredients').length > 0) {
            collectionIngredients.init();
        }
    });
}

/**
* @private
* @function
* @description Toggles answer state
*/
function toggleAnswer($optionEl) {
    const $selectedOptions = $('.js-option-block.selected');
    const defaultBgImageClass = '.js-default-responsive-bg';
    const questionBgImageClass = '.js-question-responsive-bg';
    const $copiedBg = $(defaultBgImageClass).prev(questionBgImageClass);

    if (maxAcceptedAnswers) {
        if (($selectedOptions.length > (maxAcceptedAnswers - 1)) && !$optionEl.hasClass('selected')) {
            $selectedOptions.first().removeClass('selected');
            $selectedOptions.first().find('.round-select-box').attr('aria-checked', 'false');
        }
    }

    //$optionEl.toggleClass('selected');
    if ($optionEl.hasClass('selected')) {
        $optionEl.removeClass('selected');
        $optionEl.find('.round-select-box').attr('aria-checked', 'false');
        if ($copiedBg.length) {
            $(defaultBgImageClass).fadeIn(400, function () {
                $copiedBg.remove();
            });
        }
    } else {
        $optionEl.addClass('selected');
        $optionEl.find('.round-select-box').attr('aria-checked', 'true');

        // if option is selected and has its own background
        if ($optionEl.find(questionBgImageClass).length) {
            if ($copiedBg.length) {
                $optionEl.find(questionBgImageClass).clone().prependTo($(defaultBgImageClass).parent());
                $copiedBg.fadeOut(400, function () {
                    $copiedBg.remove();
                });
            } else {
                $optionEl.find(questionBgImageClass).clone().insertBefore(defaultBgImageClass);
                $(defaultBgImageClass).fadeOut(400);
            }
        } else if ($copiedBg.length) {
            $(defaultBgImageClass).fadeIn(400, function () {
                $copiedBg.remove();
            });
        }
    }
    updateUserAnswers();

    // if option is selected and has extra info, show it on the target container below the option wrapper
    if ($optionEl.hasClass('selected') && $optionEl.has('.js-option-extra-info')){
        const infoText = $optionEl.find('.js-option-extra-info').html();
        $('.js-option-extra-info-target').html(infoText);
    } else {
        $('.js-option-extra-info-target').empty();
    }
}

/**
* @private
* @function
* @description Loads the next question with ajax
*/
function getQuestion(href){
    const $targetContainer = $('.js-gst-wrapper');

    ajax.load({
        url: href,
        target: $targetContainer,
        data: {'nocontainer': true},
        replaceTarget: true,
        callback: function() {
            pushStepToDataLayer();

            // get new question configurations
            getQuestionConfigs();

            //reselect previously selected options
            if (loadPrevAnswers) {
                loadSelectedOptions();
                //clear previous selections
                removeSelectedOptions(currentQuestionNo);
                loadPrevAnswers = false;
            }
            // re-init lazy load
            ritualsStyles.initLazyLoad();

            // re-init progress bar
            initProgressBar();
            initCustomerNameValidation();
            initQuizResult();

            // scroll to top of question (useful in mobile)
            $('html, body').animate({
                scrollTop: $('.js-gst-wrapper').offset().top - $('.js-header-wrapper').height() - 20
            }, 200);

            // push the new url to the navigation bar
            window.history.replaceState({},'', this.url);

            responsiveBg.init();

            accessibilityCheckboxAdjustment();
            stickyNavButtons();

            if ($('.js-expand-description-link').length > 0) {
                productDescription.init();
            }

            if ($('.js-collection-ingredients').length > 0) {
                collectionIngredients.init();
            }

            if ($('.js-grid-wrap').length > 0){
                grid.init();
            }

            if ($('.quiz-loader').length > 0) {
                video.initGeneric();
            }

            if ($('.js-product-slider-steps').length > 0) {
                slickSlider.init();
                productSlider.init();
                video.initGeneric();
            }

            if ($('.js-pdp-images-slider').length > 0) {
                slickSlider.init();
            }

            if ($('.js-drag-list').length > 0) {
                dragList.init();
            }

            if ($('.js-product-filter-block').length > 0) {
                productFilter.init();
            }

            if ($(document).find('.js-content-banner-blurred').length) {
                $('.js-content-banner-blurred .js-responsive-bg').addClass('blurred');
                $('.js-quiz-main-content').addClass('visible');
            } else if ($(document).find('.js-content-banner:not(.js-content-banner-blurred').length) {
                $('.js-quiz-main-content').addClass('visible');
            }
        }
    });
}

/**
* @private
* @function
* @description Clears selected options
*/
function clearData() {
    totalSelectedOptions = [];
}

/**
* @private
* @function
* @description Gets question configurations
*/
function getQuestionConfigs() {
    const questionConfig = $('.js-question').data('question-config');

    if (questionConfig) {
        numberOfAcceptedAnswers = questionConfig.numberOfAcceptedAnswers ? questionConfig.numberOfAcceptedAnswers : null;

        if (numberOfAcceptedAnswers) {
            minAcceptedAnswers = numberOfAcceptedAnswers;
            maxAcceptedAnswers = numberOfAcceptedAnswers;
        } else {
            minAcceptedAnswers = questionConfig.minAcceptedAnswers ? questionConfig.minAcceptedAnswers : 1;
            maxAcceptedAnswers = questionConfig.maxAcceptedAnswers ? questionConfig.maxAcceptedAnswers : null;
        }
    }

    //get current question number
    const progressConfig = $('.js-progress-bar').data('bar-config');
    currentQuestionNo = (progressConfig && progressConfig.currentQuestion) ? parseInt(progressConfig.currentQuestion) : 1;
}

/**
* @private
* @function
* @description Gets configurations of quiz
*/
function getQuizConfigs() {
    //get quiz configs
    const quizConfig = $('.js-quiz-container').data('quiz-config');

    if (quizConfig) {
        quizNamePrefix = (quizConfig.quizNamePrefix) ? quizConfig.quizNamePrefix : '';
        hairTempleLoadingPage = (quizConfig.hairTempleLoadingPage) ? quizConfig.hairTempleLoadingPage : '';
        startPage = (quizConfig.startPage) ? quizConfig.startPage : '';
        totalQuestionsNumber = (quizConfig.totalQuestions) ? parseInt(quizConfig.totalQuestions) : 0;
    }
}

/**
* @private
* @function
* @description Updates the user's answers when an option is toggled
*/
function updateUserAnswers() {
    const selectedOptions = $('.js-option-block.selected');

    if (selectedOptions.length >= minAcceptedAnswers && (!maxAcceptedAnswers || selectedOptions.length <= maxAcceptedAnswers)) {
        $('.js-next-question, .js-quiz-last-question').removeAttr('disabled');
    } else {
        $('.js-next-question, .js-quiz-last-question').attr('disabled', 'disabled');
    }
}

/**
 * @private
 * @function
 * @description Gets the 'link-to' data attribute from the selected options.
 * Returns null if not exists
 */
function getLinkToFromSelectedOption() {
    const $selectedOption = $('.js-option-block.selected');
    return $selectedOption.data('link-to');
}

/**
* @private
* @function
* @description Gets selected options
*/
function getSelectedOptions() {
    const result = [];

    const $selectedOptions = $('.js-option-block.selected');
    $selectedOptions.each(function(){
        const $this = $(this);

        const optionType = $this.data('option-type');
        const blockNo = $this.data('block-no');
        const dataWeight = $this.data('weight');
        const productIds = $this.data('product-ids');
        const shampooId = $this.data('shampoo-id');
        const conditionerId = $this.data('conditioner-id');

        const selectedOption = {
            'type': optionType,
            'blockNo': blockNo,
            'dataWeight': dataWeight,
            'productIds': productIds,
            'shampooId': shampooId,
            'conditionerId': conditionerId
        };

        result.push(selectedOption);
    });

    return result;
}

/**
* @private
* @function
* @description Loads previously selected options
*/
function loadSelectedOptions() {
    const selectedOptions = getSelectedOptionsByQuestion(currentQuestionNo);

    if (!!selectedOptions && selectedOptions === null) {
        return;
    }

    $.each(selectedOptions.selectedOptions, function(index, obj) {
        $('.js-option-block').filter(function() {
            if ($(this).data('block-no') == obj.blockNo) {
                toggleAnswer($(this));
            }
        });
    });
}

/**
* @private
* @function
* @description Saves selected options to the array
*/
function saveSelectedOptions() {
    const selectedOptions = getSelectedOptions();

    if (selectedOptions.length == 0){
        return;
    }

    totalSelectedOptions.push({'questionNo': currentQuestionNo, 'selectedOptions' : selectedOptions});
    pushSelectedOptionToDataLayer();
}

/**
* @private
* @function
* @description Saves the outcome into cookie
*/
function calculateAndShowResult() {
    const quizType = getQuizType();
    let targetAssetName = null;

    switch (quizType) {
        case QuizOptionTypes.Regular:
            outcome = calculateOutcomeByType();
            targetAssetName = quizNamePrefix + '-' + outcome + '.html';
            break;
        case QuizOptionTypes.HairTemple:
            outcome = calculateOutcomeByWeight();
            targetAssetName = hairTempleLoadingPage + '.html';
            break;
        default:
            break;
    }

    showQuizResult(targetAssetName);
}

/**
* @private
* @function
* @description shows the result
*/
function showQuizResult(targetAssetName) {
    let href = window.location.href;

    href = href.replace(href.substr(href.lastIndexOf('/') + 1), targetAssetName);
    getQuestion(href);
}

/**
* @private
* @function
* @description Returns selected options for given question no
*/
function getSelectedOptionsByQuestion(questionNo) {
    const result = totalSelectedOptions.filter(function(obj) {
        return obj.questionNo == questionNo;
    });
    return result ? result[0] : null;
}

/**
* @private
* @function
* @description Clears selected options of given question no
*/
function removeSelectedOptions(questionNo) {
    totalSelectedOptions = totalSelectedOptions.filter(function(obj) {
        return obj.questionNo != questionNo;
    });
}

/**
* @private
* @function
* @description Calculates outcome of the selected options
*/
function calculateOutcomeByType() {
    if (totalSelectedOptions.length == 0) {
        return;
    }

    const typeCounts = {};
    $.each(totalSelectedOptions, function(i, objQuestion) {
        $.each(objQuestion.selectedOptions, function(j, options) {
            const types = options.type.split(','); // every block may have multiple types
            $.each(types,function(k, type) {
                typeCounts[type] = (typeCounts[type] || 0) + 1;
            });
        });
    });

    let outcomeType = null;
    for (const key in typeCounts) {
        if (Object.prototype.hasOwnProperty.call(typeCounts, key)) {
            if (outcomeType === null) {
                outcomeType = key;
            } else if (typeCounts[key] > typeCounts[outcomeType]){
                outcomeType = key;
            }

        }
    }

    return outcomeType;
}

/**
* @private
* @function
* @description Calculates outcome of the selected options
*/
function calculateOutcomeByWeight() {
    if (totalSelectedOptions.length == 0) {
        return;
    }

    const quizResult = {
        elixirIds: [],
        customerName: $('input[name=PersonalizedName]').val(),
        shampooId: null,
        conditionerId: null,
        productIds: []
    };

    const weightPerElixir = {};

    $.each(totalSelectedOptions, function(i, objQuestion) {
        $.each(objQuestion.selectedOptions, function(j, option) {
            if (option.dataWeight) {
                const elixirWeight = weightPerElixir[option.type];
                if (elixirWeight) {
                    weightPerElixir[option.type] += parseInt(option.dataWeight);
                } else {
                    weightPerElixir[option.type] = parseInt(option.dataWeight);
                }
            } else if (option.productIds) {
                quizResult.productIds = quizResult.productIds.concat(option.productIds.toString().split(','));
            } else if (option.shampooId || option.conditionerId) {
                quizResult.shampooId = option.shampooId;
                quizResult.conditionerId = option.conditionerId;
            }
        });
    });

    const elixirWeights = sortWeightsDescending(weightPerElixir);

    quizResult.productIds = $.unique(quizResult.productIds.map(function(key){
        return $.trim(decodeURIComponent(key));
    }));

    quizResult.elixirIds.push(elixirWeights[0].elixirId);
    quizResult.elixirIds.push(elixirWeights[1].elixirId);

    return quizResult;
}

/**
* @private
* @function
* @description Gets the quiz type
*/
function getQuizType() {
    if ($('.js-hairtemple-quiz').length > 0) {
        return QuizOptionTypes.HairTemple;
    }

    return QuizOptionTypes.Regular;
}

/**
* @private
* @function
* @description sorts the weights from the hash map in descending order
*/
function sortWeightsDescending(weightPerElixirMap) {
    const elixirWeights = Object.keys(weightPerElixirMap).map(function(key) {
        return {'elixirId' : key, 'value' : weightPerElixirMap[key]};
    });

    return elixirWeights.sort(function(elixir1, elixir2) {
        return Number(elixir2.value) - Number(elixir1.value);
    });
}

/**
* @private
* @function
* @description Gets Progress Bar config and creates the correct dom
*/
function initProgressBar() {
    const $progressBars = $('.js-progress-bar');

    if ($progressBars.length > 0){
        $progressBars.each(function(index, ele){
            const $progressBar = $(ele);


            // add steps to the dom (one extra for styling purposes)
            for (let i = 0; i < (totalQuestionsNumber); i++) {
                const $stepElement = $('<div>', {class: 'step'});

                if (i < currentQuestionNo) {
                    $stepElement.addClass('completed');

                    // if it's the current question, add label
                    if (i == (currentQuestionNo - 1)) {
                        const currentStepLabelText = $progressBar.siblings('.js-question').find('.title').text();
                        const $currentStepLabelElement = $('<div>', {class: 'current-step-label'}).text(currentStepLabelText);
                        $stepElement.append($currentStepLabelElement);
                    }
                }

                if (i == totalQuestionsNumber){
                    $stepElement.addClass('last');
                }

                const targetFinishLabel = $progressBar.find('.js-finish-label');
                $stepElement.insertBefore(targetFinishLabel);
            }

            // show progress bar one it's ready
            $progressBar.css('display', 'flex');

        });
    }
}

function initStartAnimation() {
    if ($('.js-quiz-container .js-responsive-bg').length) {
        if ($('.js-content-banner-blurred').length) {
            setTimeout(function(){
                // blur background image
                $('.js-content-banner-blurred .js-responsive-bg').addClass('blurred')
                    .delay(500)
                    .queue(function() {
                        // make content visible
                        $('.js-quiz-main-content').addClass('visible');
                        $(this).dequeue();
                    });
            }, 1000);
        } else {
            // make content visible
            $('.js-quiz-main-content').addClass('visible');
            $(this).dequeue();
        }
    }
}

function initCustomerNameValidation() {
    if ($('input[name=PersonalizedName]').length > 0) {
        $('body').on('input', 'input[name=PersonalizedName]', function() {
            const $this = $(this);
            const $getResult = $('.js-quiz-last-question');
            let labelText;

            const maxLength = parseInt($this.attr('maxlength'));

            const charNumnberLabel = $this.nextAll('.js-charnumber');
            labelText = maxLength - $this.val().length;

            if ($this.valid()) {
                charNumnberLabel.text(maxLength - $this.val().length);
                $getResult.removeAttr('disabled');
                return;
            }

            labelText = maxLength - $this.val().length;
            charNumnberLabel.text(labelText < 0 ? 0 : labelText);

            $getResult.attr('disabled', 'disabled');
        });
    }
}

const titleUrlRegex = / /g;

function pushStepToDataLayer() {
    const question = $('.js-gst-wrapper .js-question');

    if (!question.length) {
        return;
    }

    const title = question.find('.top-wrapper .heading-h3').text().trim();
    const locale = window.location.pathname.split('/')[1];

    if (getQuizType() === QuizOptionTypes.HairTemple) {
        gtm.pushDataLayerEvent({
            'event': 'hairTemplePage',
            'virtualURL': '/' + locale + '/hair-temple/' + title.replace(titleUrlRegex, '-').toLowerCase(),
            'virtualTitle': 'Hair Temple - ' + title
        });
    }

}

function pushSelectedOptionToDataLayer() {
    const question = $('.js-gst-wrapper .js-question');
    if (!question.length) {
        return;
    }

    const title = question.find('.top-wrapper .heading-h3').text().trim();
    const selectedValues = $.map($('.js-gst-wrapper .js-question .js-option-block.selected'),function(element){
        return $(element).data('option-text-value');
    });

    if (getQuizType() === QuizOptionTypes.HairTemple) {
        gtm.pushDataLayerEvent({
            'event': 'hairTempleSelection',
            'eventCategory': 'Hair Temple',
            'eventAction': title,
            'eventLabel': selectedValues.join('|')
        });
    }
}

function initQuizResult() {
    const $viewResults = $('.js-view-results');

    if ($viewResults.length > 0) {
        const landingPageUrl = String.format('{0}?elixirIds={1}&shampooId={2}&conditionerId={3}&customerName={4}&productIds={5}&startPage={6}', Urls.hairTempleLanding,
                outcome.elixirIds, outcome.shampooId, outcome.conditionerId, outcome.customerName, outcome.productIds, startPage);
        $viewResults.attr('href', landingPageUrl);
    }
}

function accessibilityCheckboxAdjustment() {
    if ($('.js-option-block').length) {
        $('.js-option-block').each(function () {
            const $this = $(this);
            const $optionCheckbox = $this.find('.round-select-box');
            const optionText = $this.find('.option-text').html();

            $optionCheckbox.attr('role', 'checkbox').attr('aria-checked', 'false');
            $optionCheckbox.parent().append('<span class="sr-only">' + optionText + '</span>');

        });
    }
}

function stickyNavButtons() {
    const $btnPlaceholder = $('.js-nav-container');

    if (isSmallView()) {
        if ($btnPlaceholder.length) {
            const $buttons = $('.js-nav-container-inner');
            const btnHeight = $buttons.outerHeight();
            const btnHolderTopPosition = $btnPlaceholder[0].getBoundingClientRect().top;
            const btnBottomPosition = btnHolderTopPosition + btnHeight + 20;
            const windowHeight = $(window).outerHeight();

            if (btnBottomPosition < windowHeight) {
                $btnPlaceholder.removeClass('sticky-buttons');
            } else {
                $btnPlaceholder.addClass('sticky-buttons');
            }
        }
    }
}

const gst = {
    init: function () {
        pushStepToDataLayer();
        initEvents();
        getQuizConfigs();
        getQuestionConfigs();
        initProgressBar();
        initCustomerNameValidation();
    }
};

module.exports = gst;
